module.exports = __webpack_public_path__ + "img/image02.5a645fcb.jpg";